window.hasCalculator = false; // used later in blog infinite feed to remove duplicate calculators
if ($("#wagering-calculator").length) {
    window.hasCalculator = true;
    let itemLabels = {
        single: [
            "1st Place",
            "2nd Place",
            "3rd Place",
            "4th Place",
            "5th Place",
            "6th Place",
        ],
        multi: ["Race 1", "Race 2", "Race 3", "Race 4", "Race 5", "Race 6"],
    };
    let isBox = false;
    let isSingle = false;
    let $total = $(".calc-total");
    let $boxToggle = $("#calc-box-toggle");
    let $rows = $("#calc-rows");
    let $reset = $("#calc-reset");

    function hasDups(arr) {
        let unique = [...new Set(arr)]; // this automatically strips duplicate from the array
        return arr.length !== unique.length; // if unique is shorter, then there were duplicates
    }

    function cartesian(args) {
        let r = [],
            max = args.length - 1;
        function helper(arr, i) {
            for (let j = 0, l = args[i].length; j < l; j++) {
                let a = arr.slice(0); // clone arr
                a.push(args[i][j]);
                // if there are duplicates in the array, then this is an impossible bet because a horse can't finish in two positions
                // don't add this combination to the final list of all possible pets
                // we don't need to care about this in a multi-race scenario though
                if (isSingle && hasDups(a)) continue;
                if (i == max) r.push(a);
                else helper(a, i + 1);
            }
        }
        helper([], 0);
        return r;
    }

    function rowTemplate(label, i) {
        let output = `<div class="item"><div class="title">${itemLabels[label][i]}</div><div class="nums">`;
        for (let n = 1; n < 21; n++) {
            output += `<button class="num num-${n}" data-num="${n}"><span class="label">${n}</span><span class="check"></span></button>`;
        }
        output += `</div></div>`;
        return output;
    }
    function updateTotal() {
        let $rows = $(".main .item");
        let allSelections = [];
        if (!$rows.length) {
            return;
        }
        $rows.each(function (i) {
            let rowSelections = $(this).find(".selected");
            if (!rowSelections.length) {
                return;
            }
            allSelections.push(
                rowSelections.map(function () {
                    return $(this).data("num");
                }).get()
            );
        });
        if (!allSelections.length) {
            return;
        }
        let betCombinations = cartesian(allSelections);
        let total = betCombinations.length * $("#calc-bet-amount .selected").data("amount");
        $total.text("$" + total.toFixed(2));
    }

    function buildRows($typeEl) {
        $rows.html("");
        let numRows = $typeEl.data("length");
        for (let i = 0; i < numRows; i++) {
            $rows.append(rowTemplate($typeEl.data("type"), i));
        }
        $boxToggle.toggle($typeEl.data("type") === "single");
    }
    function resetTotal() {
        $total.text("$0.00");
    }

    // type buttons requre resets, so do this first
    $("#calc-bet-type button").on("click", function (e) {
        e.preventDefault();
        $("#calc-rows-heading").text("Select the Horses to Include");
        isSingle = true;
        if ($(this).data("type") === "multi") {
            isBox = false;
            isSingle = false;
            $boxToggle.removeClass("selected");
        }
        resetTotal();
        buildRows($(this));
    });
    // type and cost buttons behave the same here
    $("#wagering-calculator .choices button").on("click", function (e) {
        e.preventDefault();
        $(this).closest(".choices").find("button").removeClass("selected");
        $(this).addClass("selected");
        $reset.removeAttr("disabled");
        updateTotal();
    });
    // making selections
    $b.on("click", ".num", function (e) {
        e.preventDefault();
        if (isBox) {
            $(`[data-num="${$(this).data("num")}"]`).toggleClass("selected");
        } else {
            $(this).toggleClass("selected");
        }
        updateTotal();
    });
    // box status changes the way things behave and total calculations
    $boxToggle.on("click", function (e) {
        e.preventDefault();
        $(this).toggleClass("selected");
        resetTotal();
        isBox = $(this).hasClass("selected");
        let $selectedType = $("#calc-bet-type .selected");
        if ($selectedType.length) {
            buildRows($selectedType);
        }
    });

    $reset.on("click", function (e) {
        e.preventDefault();
        $("#wagering-calculator .choices button").removeClass("selected");
        $boxToggle.removeClass("selected");
        $boxToggle.show();
        resetTotal();
        $rows.html("");
        $("#calc-rows-heading").text(
            "Select bet amount and bet type to get started"
        );
        $(this).attr("disabled", true);
    });

    $("#calc-popover-trigger").on("click", function (e) {
        e.preventDefault();
        $("#calc-popover").addClass(site.ac);
    });
}
